import { types } from "mobx-state-tree"

export enum AgentPlanEnum {
  LITE = "lite",
  ENTERPRISE = "enterprise",
}

export const AgentProfileModel = types.model("AgentProfile").props({
  id: types.number,
  userId: types.string,
  phoneNumber: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  agentCode: types.string,
  shortBio: types.string,
  favouriteTravelDestination: types.string,
  bestTravelAdvice: types.string,
  agencyName: types.maybe(types.string),
  agencyPhoneNumber: types.maybe(types.string),
  customTerms: types.maybeNull(types.string),
  cruisesOverallVolumePercent: types.maybe(types.string),
  cruisesAnnualBookingVolume: types.maybe(types.string),
  primaryCustomerAcquisitionMean: types.maybe(types.string),
  agencyGoalsAtCruisen: types.maybe(types.array(types.string)),
  plan: types.string,
  preferredCruiseLineIds: types.array(types.number),
  agentLink: types.string,
  hostAgencyId: types.maybeNull(types.number),
  hostAgency: types.maybeNull(types.frozen()),
  consortiaId: types.maybeNull(types.number),
  consortia: types.maybeNull(types.frozen()),
  created: types.union(types.string, types.Date),
  updated: types.union(types.string, types.Date),
})
